import { loc } from "../../../../../../core/utils"
import {
  PricingRowHT,
  PricingRowLabel,
  PricingRowTTC,
  PricingRowTVA,
  PricingTableHeaders
} from "../../pricingTableComponents"
import { number, shape } from "prop-types"
import React from "react"
import { Row, Table } from "react-bootstrap"

export default function BplsPricingTable({ rent }) {
  const formatPrice = (price) => {
    if (isNaN(price)) return
    return `${price} €`
  }

  return (
    <li>
      <Row className="justify-center-row">
        <Table borderless>
          <PricingTableHeaders />
          <tbody>
            <tr>
              <PricingRowLabel label={`${loc`Rent`} ${loc`on`} ${rent?.duration || 0} ${loc`months`}*`} />
              <PricingRowHT amount={formatPrice(rent?.monthlyTotalTaxesExcluded?.toFixed(2)) || formatPrice(0)} />
              <PricingRowTVA
                amount={formatPrice(
                  (rent?.monthlyTotal - rent?.monthlyTotalTaxesExcluded)?.toFixed(2) || formatPrice(0)
                )}
              />
              <PricingRowTTC amount={formatPrice(rent?.monthlyTotal?.toFixed(2)) || formatPrice(0)} />
            </tr>
          </tbody>
        </Table>
      </Row>
    </li>
  )
}

BplsPricingTable.propTypes = {
  rent: shape({
    monthlyTotalTaxesExcluded: number,
    monthlyTotal: number,
    duration: number
  })
}
